import { motion } from "framer-motion";
import React from "react";

function Instagram() {
  return (
    <>
      <motion.svg
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 1.1 }}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#7E1DC4"
        />
        <path
          d="M17.5647 6.23072C16.1309 6.41222 14.636 6.40589 13.1315 6.26264C11.0304 6.10102 7.95976 5.13131 6.82843 7.07072C5.01099 10.1755 5.90738 14.1505 6.3309 17.6681L12.6467 23.9826C18.7586 23.658 23.657 18.7604 23.9825 12.6487L17.5647 6.23072Z"
          fill="#501A96"
        />
        <path
          d="M14.7763 5.13131H9.22372C6.96716 5.13131 5.13135 6.96712 5.13135 9.22368V14.7763C5.13135 17.0327 6.96716 18.8687 9.22377 18.8687H14.7763C17.0328 18.8687 18.8688 17.0328 18.8688 14.7763V9.22368C18.8687 6.96712 17.0329 5.13131 14.7763 5.13131ZM17.4868 14.7763C17.4868 16.2732 16.2733 17.4867 14.7763 17.4867H9.22377C7.72686 17.4867 6.51336 16.2732 6.51336 14.7763V9.22373C6.51336 7.72683 7.72686 6.51328 9.22377 6.51328H14.7763C16.2733 6.51328 17.4868 7.72687 17.4868 9.22373V14.7763Z"
          fill="#F8ECF8"
        />
        <path
          d="M12.0001 8.44697C10.041 8.44697 8.44702 10.0409 8.44702 12C8.44702 13.959 10.041 15.5529 12.0001 15.5529C13.9591 15.5529 15.5529 13.9591 15.5529 12C15.5529 10.0409 13.9591 8.44697 12.0001 8.44697ZM12.0001 14.1709C10.801 14.1709 9.82899 13.1991 9.82899 12C9.82899 10.8009 10.801 9.82894 12.0001 9.82894C13.1991 9.82894 14.171 10.8009 14.171 12C14.171 13.199 13.1991 14.1709 12.0001 14.1709Z"
          fill="#F8ECF8"
        />
      </motion.svg>
    </>
  );
}

export { Instagram };
